import { Component, input, OnDestroy, OnInit, signal } from '@angular/core';
import { ILiquidation } from '@core/models/ILiquidation';
import { PromosService } from '@core/services/promos.service';
import { environment } from '@environments/environment';
import { LiquidationModel } from 'src/app/products/components/liquidation-section/components/liquidation-card/liquidation-card.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cgw-liquidation-logo',
  standalone: true,
  imports: [],
  templateUrl: './liquidation-logo.component.html',
  styleUrl: './liquidation-logo.component.scss',
})
export class LiquidationLogoComponent implements OnInit, OnDestroy {
  public readonly idProduct = input<number>();
  public readonly liquidations = input<LiquidationModel[]>();
  public readonly liquidation = signal<LiquidationModel>(null);
  public readonly size = input<'medium' | 'small' | 'large'>();
  public assetsImage: string = environment.apiImageStatic + '/mkt/liquidacion/';
  private selectedLiquidationSubscription: Subscription;
  constructor(private _promoService: PromosService) {}

  public ngOnInit(): void {
    this.selectedLiquidationSubscription = this._promoService.selectedLiquidation?.subscribe(
      (r) => {
        if (r) {
          this.liquidation.set(this.liquidations().find((l) => l.id == r.id));
        } else {
          this.liquidation.set(this.liquidations().find((l) => l.status() == 'active'));
        }
      },
    );
  }

  public ngOnDestroy(): void {
    this.selectedLiquidationSubscription?.unsubscribe();
  }
}
